import React from 'react';
import { AlertCircle } from 'lucide-react';
import EnterpriseModal from './EnterpriseModal';

export default function ConfirmationModal({
  isOpen,
  title,
  message,
  confirmText = 'Delete',
  cancelText = 'Cancel',
  onConfirm,
  onCancel,
  isDangerous = true
}) {
  const accentColor = isDangerous ? 'var(--color-danger)' : 'var(--color-warning)';
  const accentColorDark = isDangerous ? 'var(--color-danger-dark)' : '#d97706';
  const accentRgb = isDangerous ? '239, 68, 68' : '217, 119, 6';

  return (
    <EnterpriseModal
      isOpen={isOpen}
      onClose={onCancel}
      size="sm"
      hideCloseButton
      bodyPadding="0"
      footer={
        <div style={{ display: 'flex', gap: '0.75rem' }}>
          <button
            onClick={onCancel}
            style={{
              flex: 1,
              backgroundColor: 'var(--color-border)',
              color: 'var(--color-text-primary)',
              padding: '0.625rem 1rem',
              borderRadius: '0.5rem',
              border: 'none',
              cursor: 'pointer',
              fontWeight: '500',
              fontSize: '0.875rem',
              transition: 'all 0.2s ease'
            }}
            onMouseEnter={(e) => (e.target.style.opacity = '0.85')}
            onMouseLeave={(e) => (e.target.style.opacity = '1')}
          >
            {cancelText}
          </button>
          <button
            onClick={onConfirm}
            style={{
              flex: 1,
              backgroundColor: accentColor,
              color: 'white',
              padding: '0.625rem 1rem',
              borderRadius: '0.5rem',
              border: 'none',
              cursor: 'pointer',
              fontWeight: '500',
              fontSize: '0.875rem',
              transition: 'all 0.2s ease'
            }}
            onMouseEnter={(e) => {
              e.target.style.backgroundColor = accentColorDark;
              e.target.style.boxShadow = `0 4px 12px rgba(${accentRgb}, 0.3)`;
            }}
            onMouseLeave={(e) => {
              e.target.style.backgroundColor = accentColor;
              e.target.style.boxShadow = 'none';
            }}
          >
            {confirmText}
          </button>
        </div>
      }
    >
      <div style={{ padding: '1.5rem' }}>
        {/* Icon and Title */}
        <div style={{
          display: 'flex',
          alignItems: 'center',
          gap: '0.75rem',
          paddingBottom: '1rem',
          borderBottom: '1px solid var(--color-border)',
          marginBottom: '1rem'
        }}>
          <AlertCircle
            size={24}
            style={{ color: accentColor, flexShrink: 0 }}
          />
          <h2
            id="em-modal-title"
            style={{
              fontSize: '1.25rem',
              fontWeight: 'bold',
              color: 'var(--color-text-primary)',
              margin: 0
            }}
          >
            {title}
          </h2>
        </div>

        {/* Message */}
        <p style={{
          color: 'var(--color-text-secondary)',
          fontSize: '0.95rem',
          lineHeight: '1.5',
          margin: 0
        }}>
          {message}
        </p>
      </div>
    </EnterpriseModal>
  );
}
